import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=63ac6c1b&scoped=true"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac6c1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ac6c1b')) {
      api.createRecord('63ac6c1b', component.options)
    } else {
      api.reload('63ac6c1b', component.options)
    }
    module.hot.accept("./AddPage.vue?vue&type=template&id=63ac6c1b&scoped=true", function () {
      api.rerender('63ac6c1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decoration/AddPage.vue"
export default component.exports